import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { kayabaPageMeta, kayabaSchema } from 'components/common/schema'
import Template from 'components/cases/kayaba'

const Kayaba: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...kayabaPageMeta} />
      <JsonLd data={kayabaSchema} />
      <Template />
    </>
  )
}

export default Kayaba
